// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remain-title[data-v-1b6b9ec8]{color:red;font-size:13px;padding-top:10px;opacity:.8}.grey[data-v-1b6b9ec8]{color:#c0c4cc!important}.random[data-v-1b6b9ec8]{margin-left:20px;cursor:pointer;font-size:16px}", ""]);
// Exports
module.exports = exports;
